import {
  Box,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Radio,
  RadioGroup,
  useDisclosure
} from '@chakra-ui/react'
import { QueryPopoverButton } from './QueryPopover'

type Props = {
  radioLabels: string[]
  radioLabelGetter: (label: string) => string
  label: string | undefined
  value: string
  /**
   * デフォルト状態ではなく、フィルターがセットされているか
   */
  isFiltered?: boolean
  defaultLabel: string
  onChange?: (value: string) => void
}
export const QueryRadioPopover: React.FC<Props> = ({
  radioLabels,
  radioLabelGetter,
  value,
  onChange,
  ...buttonProps
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  return (
    <Popover isOpen={isOpen} onClose={onClose} onOpen={onOpen}>
      <PopoverTrigger>
        <QueryPopoverButton {...buttonProps} />
      </PopoverTrigger>
      <PopoverContent
        w="min-content"
        _focus={{
          boxShadow: 'none'
        }}
      >
        <PopoverBody bgColor="white.100" p="0">
          <RadioGroup
            w="160px"
            value={value}
            onChange={(nextValue) => {
              onChange?.(nextValue)
              onClose()
            }}
          >
            <Box>
              {radioLabels.map((label) => (
                <Radio
                  d="flex"
                  id={label}
                  key={label}
                  value={label}
                  size="sm"
                  lineHeight="20px"
                  textAlign="center"
                  py="2px"
                  pl="18.5"
                  h="36px"
                  _hover={{
                    bgColor: 'gray.80'
                  }}
                >
                  {radioLabelGetter(label)}
                </Radio>
              ))}
            </Box>
          </RadioGroup>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
